<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="room">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            文章标题
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit" @click.native="handleEdit">编辑</el-button>
                    <div style="float:right">
                        <el-input  placeholder="请输入标题名称" v-model="titleSearch" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-select v-model="statusSearch" placeholder="选择标题状态" style="margin:0 10px;" >
                            <el-option
                                    v-for="item in statusValue"
                                    :key="item.val"
                                    :label="item.name"
                                    :value="item.val">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick'>

                        <el-table-column prop="title" label="标题名称"></el-table-column>

                        <el-table-column
                                prop="Status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
        <el-dialog title='标题添加' :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh' :close-on-click-modal='false'>
            <el-input v-model="titleAdd" placeholder="请输入标题名称"></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="batchDialog=false">取 消</el-button>
                <el-button type="primary"  @click="addSub">提交</el-button>
            </div>
        </el-dialog>
        <el-dialog title='标题修改' :visible.sync="batchDialogEdit" class="dialog" width='400px' center top='30vh' :close-on-click-modal='false'>
            <el-input v-model="titleEdit" placeholder="请输入标题名称"></el-input>
            <el-select v-model="status" placeholder="选择标题状态" style="margin-top:20px;width:100%">
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="2"></el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click="batchDialogEdit=false">取 消</el-button>
                <el-button type="primary"  @click="editSub">提交</el-button>
            </div>
        </el-dialog>
        <!-- <Add ref="myAdd" v-show="showModalAdd"  v-bind:roomTypeList="roomTypeList" v-bind:buildingCodeValue="buildingCodeValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:roomTypeList="roomTypeList"  v-bind:buildingCodeValue="buildingCodeValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit> -->

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    // import Edit from "./Edit";
    // import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                disabledEdit:false,
                tableData:null,
                status:-1,
                statusSearch:-1,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                batchDialog:false,
                batchDialogEdit:false,
                titleAdd:'',
                titleEdit:'',
                titleSearch:'',
                infoTitleCode:'',
                selectInfo:'',
                statusValue:[{
                    val:-1,
                    name:'全部'
                },{
                    val:1,
                    name:'正常'
                },{
                    val:2,
                    name:'禁用'
                }],
            }
        },
        created(){
            this.getList();
            this.init();
            this.th = this.$store.state.tableHeight;
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            init:function(){
            },
            handleEdit() {
                this.infoTitleCode=this.selectInfo.infoTitleCode;
                this.titleEdit=this.selectInfo.title;
                this.status=this.selectInfo.status;
                this.batchDialogEdit=true
            },
            toggleModalAdd:function(){
                this.titleAdd='';
                this.batchDialog =true;
            },
            addSub(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InfoTitle/Add",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        title:this.titleAdd
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.batchDialog=false
                        this.getList();
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            editSub(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InfoTitle/Edit",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        infoTitleCode:this.infoTitleCode,
                        title:this.titleEdit,
                        status:this.status
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.batchDialogEdit=false
                        this.getList();
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InfoTitle/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        title:this.titleSearch,
                        status:this.statusSearch,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        this.disabledEdit=true
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                const statusValue=this.statusValue
                for(var i in statusValue){
                    if(statusValue[i].val==row.status){
                        return statusValue[i].name
                    }
                }   
            },
             rowClick(row){
                this.selectInfo=row
                this.disabledEdit=false
            }
        }
    }
</script>

<style lang='scss' scoped>
    .room /deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }
</style>
